export default {picturePanel:{titles:['Exploration','Intimité','Événement','Connexion','Érotisme'],subTitle:'La rencontre entre parenthèse'}};